
import {createSlice} from "@reduxjs/toolkit";

export const contractDrilldownSliceCS = createSlice({
    name: 'contractDrilldownSlcCS',
    initialState: {value: {

        csDrawerState: false,
            csDrawerMode: null,
            csGridRefresh: false,

            mousedId: 0,
            mousedContractId:null,
            mousedParentSectionId: null,
            mousedParentOrdinalNumber: null,
            mousedParentRecordLevel: null,
            mousedParentMcode: null,
            mousedParentName: null,
            mousedParentDescription: null,
            mousedPreviousSectionId: null,
            mousedPreviousOrdinalNumber: null,
            mousedPreviousRecordLevel: null,
            mousedPreviousMcode: null,
            mousedPreviousName: null,
            mousedPreviousDescription: null,
            mousedOrdinalNumber: null,
            mousedRecordLevel: null,
            mousedMcode:null,
            mousedName: null,
            mousedDescription: null,
            mousedShortName: null,
            mousedStatus: null,
            mousedHierarchy: null,
            mousedCreatedOn: null,
            mousedCreatedBy:null,
            mousedLastModifiedOn:null,
            mousedLastModifiedBy:null,
            mousedCsDrawerState: false,
            mousedCsDrawerMode: null,
            mousedCsGridRefresh: false,
            mousedType: null,
            mousedContents: null,

            queryFinancialsDataPointId: null, QfDrawerState: false, QfDrawerMode: "Dropdown"
    }},
    reducers:
{
    changeContractDrilldownCS: (state, action) => {
        state.value = {
            ...state.value,  // Keep existing fields
            ...action.payload // Merge new values
        };
    }
}
});

export const { changeContractDrilldownCS } = contractDrilldownSliceCS.actions;

export default  contractDrilldownSliceCS.reducer ;
